import React from 'react'

const TeamRankBlock = (props) => {
  return (
    <div className='rounded-lg bg-slate-50 p-2 text-center m-2 hover:bg-slate-100 cursor-pointer shadow-sm' onClick={() => props.onClick()}>
        <div className='text-lime-600'><span className='text-2xl'>{props.rank}</span>位</div>
        <div className='text-gray-600 mb-2'>{props.name}</div>
        <i className='bi bi-coin text-yellow-500 me-1'></i><span className='font-bold text-lime-600'>{props.score}</span> pt
    </div>
  )
}

export default TeamRankBlock